<template>
  <div>
    <Row>
      <Col :xs="12" :s="4" :l="3" hasMargin>
        <Link
          :onClick="() => onLinkClick($t('profile.legal.form.privacyStatement'))"
          :to="ROUTE_PRIVACY"
          weight="regular"
          external
        >
          {{ $t('profile.legal.form.privacyStatement') }}
        </Link>
      </Col>
      <Col :xs="12" :s="8" :l="9" hasMargin>
        <span
          v-html="
            $t('profile.legal.privacyStatement.accepted', {
              date: formatDate(this.user.privacyStatementAcceptedOn),
            })
          "
        />
      </Col>
    </Row>
  </div>
</template>

<script>
import Row from '@/components/Grid/Row/Row';
import Col from '@/components/Grid/Col/Col';
import Link from '@/objects/Link';

import { mapFieldsUser } from '@/store/mapFields';
import { ROUTE_PRIVACY } from '@/constants/routes';
import { formatDate } from '@/helpers/formatter';

export default {
  name: 'LegalForm',
  components: { Link, Col, Row },
  props: {
    el: String,
  },
  computed: {
    ...mapFieldsUser(['user']),
  },

  data() {
    return {
      ROUTE_PRIVACY,
      formatDate,
    };
  },

  methods: {
    onLinkClick(label) {
      this.$emit('onTrackingClick', '_link-' + label, 'link');
    },
  },
};
</script>
